<div mat-dialog-title>
  <div class="row">
    <div class="col-sm-10">
      <mat-label class="dialog-title">{{ title }}</mat-label>
      @if(description){
      <p>{{ description }}</p>
      }
    </div>
    <div class="col-sm-2 right-aligned">
      <mat-icon (click)="onCancel()">close</mat-icon>
    </div>
  </div>
</div>


<mat-dialog-content>
  <form class="report-form" [formGroup]="breakInOutForm">
    <div class="horizontal-form-field">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>{{ 'COMMON.LABELS.JUSTIFICATION' | translate }}</mat-label>
        <textarea
          matInput
          formControlName="justification"
          maxlength="20000"
          required
        ></textarea>
        <mat-error
          *ngIf="
            breakInOutForm.get('justification')?.hasError('required') &&
            breakInOutForm.get('justification')?.touched
          "
        >
          {{ 'COMMON.LABELS.REQUIRED_FIELD' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="project-totals-grid">
      <table cellpadding="0" cellspacing="4" border="0">
        <tr>
          <td>{{ 'COMMON.LABELS.MONTH' | translate }}&nbsp;</td>
          <td>{{ 'COMMON.COST_TYPES.MATERIAL' | translate }}</td>
          <td>{{ 'COMMON.COST_TYPES.SERVICE' | translate }}</td>
          <td>{{ 'COMMON.COST_TYPES.OTHER' | translate }}</td>
          <td>{{ 'COMMON.COST_TYPES.TOTAL' | translate }}</td>
        </tr>

        <tr>
          <td>{{ 'COMMON.MONTHS_SHORT.JAN' | translate }}</td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="janMaterial"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="janService"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="janOther"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="janTotal"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
        </tr>

        <tr>
          <td>{{ 'COMMON.MONTHS_SHORT.FEB' | translate }}</td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="febMaterial"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="febService"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="febOther"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="febTotal"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
        </tr>

        <tr>
          <td>{{ 'COMMON.MONTHS_SHORT.MAR' | translate }}</td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="marMaterial"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="marService"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="marOther"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="marTotal"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
        </tr>

        <tr>
          <td>{{ 'COMMON.MONTHS_SHORT.APR' | translate }}</td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="aprMaterial"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="aprService"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="aprOther"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="aprTotal"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
        </tr>

        <tr>
          <td>{{ 'COMMON.MONTHS_SHORT.MAY' | translate }}</td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="mayMaterial"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="mayService"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="mayOther"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="mayTotal"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
        </tr>

        <tr>
          <td>{{ 'COMMON.MONTHS_SHORT.JUN' | translate }}</td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="junMaterial"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="junService"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="junOther"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="junTotal"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
        </tr>

        <tr>
          <td>{{ 'COMMON.MONTHS_SHORT.JUL' | translate }}</td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="julMaterial"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="julService"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="julOther"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="julTotal"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
        </tr>

        <tr>
          <td>{{ 'COMMON.MONTHS_SHORT.AUG' | translate }}</td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="augMaterial"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="augService"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="augOther"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="augTotal"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
        </tr>

        <tr>
          <td>{{ 'COMMON.MONTHS_SHORT.SEP' | translate }}</td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="sepMaterial"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="sepService"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="sepOther"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="sepTotal"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
        </tr>

        <tr>
          <td>{{ 'COMMON.MONTHS_SHORT.OCT' | translate }}</td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="octMaterial"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="octService"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="octOther"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="octTotal"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
        </tr>

        <tr>
          <td>{{ 'COMMON.MONTHS_SHORT.NOV' | translate }}</td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="novMaterial"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="novService"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="novOther"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="novTotal"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
        </tr>

        <tr>
          <td>{{ 'COMMON.MONTHS_SHORT.DEC' | translate }}</td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="decMaterial"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="decService"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="decOther"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="decTotal"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
        </tr>

        <tr>
          <td>{{ 'COMMON.COST_TYPES.TOTAL' | translate }}</td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="totalMaterial"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="totalService"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="totalOther"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" class="full-width">
              <input
                matInput
                type="number"
                (input)="calculateTotals()"
                formControlName="total"
                maxlength="20000"
              />
            </mat-form-field>
          </td>
        </tr>
      </table>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button class="submit" (click)="onSave()">{{ 'COMMON.BUTTONS.SAVE' | translate }}</button>
  <button mat-button class="discard-changes" (click)="onCancel()">
    {{ 'COMMON.BUTTONS.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
